import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CredentialsService } from '@app/modules/authentication/credentials.service';
import { environment } from '@env/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private credentialsService: CredentialsService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Get the auth token from the service.
    const authToken = this.credentialsService.credentials?.token;
    let isVendorApiReq = [environment.apiUrl, environment.transactionsUrl, environment.profileUrl, environment.merchantUrl].some(
      (url) => req.url.includes(url)
    );

    // Check if the request is for public endpoints that don't need authorization
    const isPublicEndpoint = req.url.includes('/countries') || 
                            req.url.includes('/cities') ||
                            // Add any other public endpoints here
                            req.url.includes('/PickupLocation/countries') ||
                            req.url.includes('/PickupLocation/cities');

    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.
    if (isVendorApiReq && !isPublicEndpoint) {
      if (!req.headers.get("Authorization")) {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${authToken}`,
          },
        });
      }
    }

    // send cloned request with header to the next handler.
    return next.handle(req);
  }
}
